import clsx from 'clsx';

import styles from './DallasCard.module.scss';
import DallasStack from '../Stack/DallasStack';
import DallasDivider from '../Dividers/DallasDivider';
import type { DallasSpacing } from '../types/spacing';
import { DallasElevation } from '../types/elevation';

import boxShadowStyles from '@ui/Dallas/styles/box-shadow.module.scss';

export interface CommonCardProps {
  className?: string;
  elevation?: DallasElevation;
  bordered?: boolean;
}

export interface Props extends CommonCardProps {
  padding?: DallasSpacing;
  gap?: DallasSpacing;
  header?: React.ReactNode;
  content?: React.ReactNode;
  footer?: React.ReactNode;
  withHeaderDivider?: boolean;
  withFooterDivider?: boolean;
}

export default function DallasCard({
  className,
  padding = 'md',
  gap = 'md',
  header,
  content,
  footer,
  withHeaderDivider = false,
  withFooterDivider = false,
  elevation = 0,
  bordered = false,
}: Props) {
  return (
    <DallasStack
      className={clsx(
        styles.relative,
        className,
        styles.root,
        bordered && styles.bordered,
        boxShadowStyles[`elevation_${elevation}`],
      )}
      gap={gap}
      paddingHorizontal={padding}
      paddingVertical={padding}
    >
      {header && (
        <>
          {header}
          {withHeaderDivider && <DallasDivider />}
        </>
      )}
      {content}
      {footer && (
        <>
          {withFooterDivider && <DallasDivider />}
          {footer}
        </>
      )}
    </DallasStack>
  );
}
